const OWL_NS = 'http://www.w3.org/2002/07/owl#';
const RDFS_NS = 'http://www.w3.org/2000/01/rdf-schema#';
const RDF_NS = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';

interface Probe {
  label: string;
  namespace: string;
  localName: string;
}

// Everything the editor's model cannot represent. Saving drops these silently, so
// they are named explicitly rather than hidden behind a generic disclaimer.
const PROBES: Probe[] = [
  { label: 'owl:imports', namespace: OWL_NS, localName: 'imports' },
  { label: 'owl:NamedIndividual', namespace: OWL_NS, localName: 'NamedIndividual' },
  { label: 'owl:Restriction', namespace: OWL_NS, localName: 'Restriction' },
  { label: 'owl:equivalentClass', namespace: OWL_NS, localName: 'equivalentClass' },
  { label: 'owl:disjointWith', namespace: OWL_NS, localName: 'disjointWith' },
  { label: 'owl:AnnotationProperty', namespace: OWL_NS, localName: 'AnnotationProperty' },
  { label: 'owl:inverseOf', namespace: OWL_NS, localName: 'inverseOf' },
  { label: 'owl:versionInfo', namespace: OWL_NS, localName: 'versionInfo' },
  { label: 'rdfs:subClassOf', namespace: RDFS_NS, localName: 'subClassOf' },
  { label: 'rdfs:subPropertyOf', namespace: RDFS_NS, localName: 'subPropertyOf' },
  { label: 'rdfs:seeAlso', namespace: RDFS_NS, localName: 'seeAlso' },
  { label: 'rdfs:isDefinedBy', namespace: RDFS_NS, localName: 'isDefinedBy' },
  { label: 'rdf:Description', namespace: RDF_NS, localName: 'Description' },
];

export interface UnsupportedConstruct {
  label: string;
  count: number;
}

function countComments(node: Node): number {
  let count = 0;

  for (const child of Array.from(node.childNodes)) {
    if (child.nodeType === Node.COMMENT_NODE) {
      count += 1;
    }

    count += countComments(child);
  }

  return count;
}

/**
 * Names the parts of a document that will not survive an edit, so the user can
 * judge the diff instead of discovering the loss in review.
 */
export function findUnsupportedConstructs(rdfXml: string): UnsupportedConstruct[] {
  const document = new DOMParser().parseFromString(rdfXml, 'application/xml');

  if (document.querySelector('parsererror')) {
    return [];
  }

  const found = PROBES
    .map(({ label, namespace, localName }) => ({
      label,
      count: document.getElementsByTagNameNS(namespace, localName).length,
    }))
    .filter((construct) => construct.count > 0);

  const comments = countComments(document);

  return comments > 0
    ? [...found, { label: 'XML comments', count: comments }]
    : found;
}
